import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LecturesRoutingModule} from './lectures-routing.module';
import {LecturesComponent} from './lectures.component';
import {AddLectureComponent} from './add-lecture/add-lecture.component';
import {ContentHeaderModule} from '../../layout/components/content-header/content-header.module';
import {TranslateModule} from '@ngx-translate/core';
import {CoreCommonModule} from '../../../@core/common.module';
import {CoreDirectivesModule} from '../../../@core/directives/directives';
import {CardSnippetModule} from '../../../@core/components/card-snippet/card-snippet.module';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {CoreSidebarModule} from '../../../@core/components';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';


@NgModule({
    declarations: [LecturesComponent, AddLectureComponent],
    imports: [
        CommonModule,
        LecturesRoutingModule,
        ContentHeaderModule,
        TranslateModule,
        CoreCommonModule,
        CoreDirectivesModule,
        CardSnippetModule,
        NgxDatatableModule,
        CoreSidebarModule,
        NgbPaginationModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [LecturesComponent, AddLectureComponent]
})
export class LecturesModule {
}
